import React, {Component, Fragment} from "react";
import { Navbar} from "react-bootstrap";

class SpyMenu extends Component  {
  render(){
    if(!this.props.categories){
      return <div>loading...</div>
    }

    let items = [];
    this.props.categories.map(item => items.push(item.name))
      return (
        <Fragment>
          <div className="sticky-top">
              <Navbar bg="light" variant="light" expand="lg"  className="testimonial-group">
                    <div className="row text-center flex-nowrap">
                        {
                          items.map((item, i) =>  {
                            let itemName = JSON.parse(item)[this.props.lang.toUpperCase()];
                            return <div key={i} className="col-sm-4"><a href={"#"+ itemName}>{itemName}</a></div>

                          })
                        }
                    </div>
                </Navbar>
          </div>
        </Fragment>
      );
    }

}

export default SpyMenu;

